import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function to merge Tailwind CSS classes
 * Combines clsx for conditional classes and tailwind-merge for conflict resolution
 * 
 * @param {...any} inputs - Class names to merge
 * @returns {string} Merged class string
 * 
 * @example
 * cn('px-4 py-2', isActive && 'bg-blue-500', className)
 * cn('text-sm', 'text-lg') // text-lg wins (tailwind-merge handles conflicts)
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
